import axios from 'axios';
import { config } from '@surgia/config';
import { getAccessToken } from '@surgia/utils';

// Create axios instance with interceptors
const apiClient = axios.create({
  baseURL: config.api.baseUrl,
  timeout: config.api.timeout,
  headers: {
    ...config.api.headers
  }
});

// Single request interceptor (auth + logging)
apiClient.interceptors.request.use(
  (config) => {
    // Use storage helper to get token from Redux (primary) or localStorage (fallback)
    const token = getAccessToken();
    
    console.log('🔑 [API] Request interceptor:', {
      url: config.url,
      method: config.method,
      hasToken: !!token,
      tokenPreview: token ? `${token.substring(0, 20)}...` : 'NO TOKEN',
    });
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('⚠️ [API] NO TOKEN AVAILABLE - Request will be sent without Authorization header!');
      console.warn('⚠️ [API] localStorage.token:', !!localStorage.getItem('token'));
      console.warn('⚠️ [API] localStorage[persist:root]:', !!localStorage.getItem('persist:root'));
    }
    
    return config;
  },
  (error) => {
    console.error('Request error:', error);
    if (error.response?.status === 401) {
      // Dispatch custom event when 401 occurs
      window.dispatchEvent(new CustomEvent('auth:logout', {
        detail: {
          reason: 'unauthorized',
          timestamp: new Date().toISOString()
        }
      }));
    }
    return Promise.reject(error);
  }
);

// Single response interceptor (auth + logging + error handling)
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    console.error('🌐 [API] Response error:', error);
    console.error('🌐 [API] Error details:', {
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      url: error.config?.url,
      hasResponse: !!error.response
    });
    
    // Handle 401 - refresh token
    if (error.response?.status === 401) {
      console.error('🚨 [API] 401 UNAUTHORIZED - Dispatching logout event');
      console.error('🚨 [API] Request URL:', error.config?.url);
      console.error('🚨 [API] Request method:', error.config?.method);
      
      window.dispatchEvent(new CustomEvent('auth:logout', {
        detail: {
          reason: 'unauthorized',
          timestamp: new Date().toISOString(),
          url: error.config?.url
        }
      }));
    } else if (!error.response) {
      console.error('🌐 [API] Network error (no response) - NOT triggering logout');
    } else {
      console.error('🌐 [API] HTTP error', error.response.status, '- NOT triggering logout');
    }
    
    return Promise.reject(error);
  }
);

export { apiClient }; 